// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__Fp9CR","btn":"NotFound_btn__OyFp1"};